module.exports = __webpack_public_path__ + "media/images/emblems/Baar-coat_of_arms-d3aa7f14c36b73c192063a4c855fbbe1.svg";